export default __webpack_public_path__ + "static/media/sound_spot_FINAL.d7f2d647.png";